import { render, staticRenderFns } from "./HoraInicio.vue?vue&type=template&id=3b141e07"
import script from "./HoraInicio.vue?vue&type=script&lang=js"
export * from "./HoraInicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports